"use client";

import { usePathname } from "next/navigation";

export default function usePath() {
  const pathName = usePathname();

  return pathName;
}
